<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<!--banner-->
			<div v-if="bannerList" class="banner_box">
				<van-swipe
					class="swipe_box"
					:autoplay="5000"
					:show-indicators="true"
					:stop-propagation="false"
					indicator-color="#C8000A"
				>
					<van-swipe-item
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						v-for="(value, index) in bannerList"
						:key="index"
						@click.stop="goBannerInfo(value)"
					>
						<div class="swiper_el">
							<img class="bg" :src="webUrl + value.image" @dragstart.prevent />
						</div>
					</van-swipe-item>
				</van-swipe>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main">
					<div
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						class="top_box"
					>
						<!-- <div class="tit_en">Abiores</div> -->
						<div class="tit">Abiores</div>
					</div>
					<div class="text_box">
						<div
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="300"
							data-aos-offset="0"
							data-aos-once="true"
							class="tit"
						>Specializing in the research and development, production, sales and technical services of in vitro diagnostic reagents</div>
						<div
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="500"
							data-aos-offset="0"
							data-aos-once="true"
							class="txt"
						>
							<div>
								Abiores is a subsidiary of Cordx Union (CU), Abiores is a high-tech enterprise specializing in the R&D, production, sales and technical services of in vitro diagnostic (IVD) products. The company has an independent R&D center, quality inspection center and GMP plants of grade 100,000 and grade 10,000 (local grade 100) standards, with full sets of molecular diagnostic reagent production lines and corresponding supporting facilities.
							</div>
							<div>
								Abiores now owns Magnetic Beads Technology Platform, Micro Nucleic Acid Releasing Reagent Platform (One-tube Method) and Automated Nucleic Acid Extraction Platform, and has developed fluorescence PCR products for Hepatitis B, Hepatitis C, HIV, hand, foot and mouth disease and respiratory diseases, etc.
							</div>
						</div>
						<div
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="500"
							data-aos-offset="0"
							data-aos-once="true"
							class="txt"
						>Science Park</div>
					</div>
					<div
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						class="num_main"
					>
						<div class="num_box">
							<count-to :startVal="0" :endVal="4" :duration="3000" class="num"></count-to>
							<div class="icon_1">+</div>
							<div class="icon_2" style="right: -45px;">hectares</div>
						</div>
						<div class="num_box" style="margin-left: 70px;">
							<count-to :startVal="0" :endVal="3" :duration="5000" class="num"></count-to>
							<span style="position: relative;left: -8px;">W</span>
							<div class="icon_1" style="right: -8px;">+</div>
							<div class="icon_2" style="right: -8px;">㎡</div>
						</div>
					</div>
				</div>
				<img
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
					class="bg"
					src="../../assets/img_public/index/block1.webp"
				/>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div v-if="false" class="block_2_main">
					<div
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						class="top_box"
					>
						<!-- <div class="tit_en">Solution</div> -->
						<div class="tit">Solution</div>
						<!-- <div class="txt">宝瑞源为您提供专业、多样化的解决方案</div> -->
					</div>
					<div v-if="solutionList.length > 0" class="list_box">
						<div
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="200"
							data-aos-offset="0"
							data-aos-once="true"
							v-for="(value, index) in solutionList"
							:key="index"
							class="list_el"
							@click="goProduct(1, value)"
						>
							<img :src="webUrl + value.icon_active" />
							<div class="tit">{{ value.title }}</div>
							<van-icon name="arrow" color="#9F9F9F" size="20px" />
						</div>
					</div>
				</div>
				<div
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
					class="bot_box_1"
				>
					<!-- <div class="tit_en">Our Services</div> -->
					<div class="txt">Our Services</div>
					<div class="tit">We provide high-quality services for pharmaceutical peers</div>
					<div class="txt_en">Medical equipment & Diagnostic reagent</div>
				</div>
				<div
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
					class="bot_box_2"
				>
					<img src="../../assets/img_public/index/block4.webp" />
					<!-- <div class="msg_box">
						<div class="num_box" style="right: 90px;">
							<count-to :startVal="0" :endVal="170" :duration="5000" class="num"></count-to>
							<div class="icon_1" style="top: -8px;">+</div>
							<div class="icon_2" style="right: -100px;">Market coverage<br />countries and regions</div>
						</div>
						<div class="num_box" style="left: 30px;">
							<count-to :startVal="0" :endVal="100" :duration="5000" class="num"></count-to>
							<div class="icon_1" style="top: -8px;">+</div>
							<div class="icon_2" style="right: -62px;">Million Users</div>
						</div>
					</div> -->
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3">
				<div class="block_3_main">
					<div
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						class="top_box"
					>
						<!-- <div class="tit_en">Our Products</div> -->
						<div class="tit">Our Products</div>
						<!-- <div class="txt">安全有效的体外检测产品供您选择</div> -->
					</div>
					<div v-if="productTypeList.length > 0" class="list_box">
						<div
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="300"
							data-aos-offset="0"
							data-aos-once="true"
							v-for="(value, index) in productTypeList"
							:key="index"
							v-if="value.title != 'Solution'"
							class="list_el"
							@click="goProduct(2, value)"
						>
							<img :src="webUrl + value.icon_active" />
							<div class="tit">{{ value.title }}</div>
							<van-icon name="arrow" color="#9F9F9F" size="20px" />
						</div>
					</div>
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div class="block_4">
				<div class="block_4_el" @click="goCulture">
					<img
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						src="../../assets/img_public/index/block2.webp"
					/>
					<div
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
						class="msg_box"
					>
						<div class="tit">Corporate Culture</div>
						<!-- <div class="tit_en">Corporate Culture</div> -->
					</div>
				</div>
				<div class="block_4_el" @click="goHonor">
					<img
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						src="../../assets/img_public/index/block3.webp"
					/>
					<div
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
						class="msg_box"
					>
						<div class="tit">Honors And Qualifications</div>
						<!-- <div class="tit_en">Honors And Qualifications</div> -->
					</div>
				</div>
			</div>
			<!--块4-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import CountTo from 'vue-count-to'
import { UPURL } from '@/util/util';
export default {
	components:{
		navBox,
		footerBox,
		CountTo
	},
	data() {
		return {
			isLoading: true,  //界面loading
			bannerList: [],
			solutionList: [],  //解决方案列表
			productTypeList: [],  //产品分类列表1
			webUrl: UPURL,
		}
	},
	created(){
		let that = this;
		if(sessionStorage.getItem('navList')) {
			that.solutionList = JSON.parse(sessionStorage.getItem('navList'))[1].children.scenarios_list;
			that.productTypeList = JSON.parse(sessionStorage.getItem('navList'))[1].children.cate_list;
		}
	},
	mounted() {
		let that = this;
		if(sessionStorage.getItem('bannerList')) {
			let bannerData = JSON.parse(sessionStorage.getItem('bannerList'));
			bannerData.forEach((value, index) => {
				if(value.leixing == 2) {
					that.bannerList.push(value);
				}
			});
			that.isLoading = false;
		}
	},
	watch: {
		//
	},
	methods: {
		//点击查看轮播图详情
		goBannerInfo(value) {
			if(value.url) {
				window.location.href = value.url;
			}
		},
		//点击进入产品
		goProduct(type, value) {
			let that = this;
			switch(type) {
				case 1:
					that.$router.push({ path: '/product.html', query: { scenarios_ids: value.id } });
					setTimeout(() => {
						window.location.reload();
					}, 300);
				break;
				case 2:
					that.$router.push({ path: '/product.html', query: { cate_ids: value.id } });
					setTimeout(() => {
						window.location.reload();
					}, 300);
				break;
			}
		},
		//跳转企业文化
		goCulture() {
			let that = this;
			that.$router.push({ path: '/about/culture.html' });
		},
		//跳转荣誉资质
		goHonor() {
			let that = this;
			that.$router.push({ path: '/about/honor.html' });
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #333333;
	//块4
	.block_4{
		.block_4_el:last-child{
			margin-bottom: 0;
		}
		.block_4_el{
			position: relative;
			margin-bottom: 10px;
			.msg_box{
				width: 100%;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				text-align: center;
				.tit_en{
					font-size: 14px;
					color: #ffffff;
				}
				.tit{
					font-size: 24px;
					font-weight: bold;
					color: #ffffff;
				}
			}
			img{
				width: 100%;
			}
		}
	}
	//块3
	.block_3{
		.block_3_main{
			padding: 60px 16px 0 16px;
			.list_box{
				padding: 25px 0 60px 0;
				.list_el{
					display: flex;
					align-items: center;
					padding: 15px 0;
					border-bottom: 1px solid #D1D1D1;
					.tit{
						flex: 1;
						padding: 0 15px;
						font-size: 16px;
					}
					img{
						width: 36px;
					}
				}
			}
		}
	}
	//块2
	.block_2{
		.bot_box_2{
			position: relative;
			.msg_box{
				position: absolute;
				z-index: 1;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}
			img{
				width: 100%;
			}
		}
		.bot_box_1{
			padding: 60px 0;
			text-align: center;
			background-color: #C8000A;
			.txt{
				color: #ffffff;
			}
			.tit{
				line-height: 1.2;
				font-size: 24px;
				padding: 10px;
				font-weight: bold;
				color: #ffffff;
			}
			.txt_en{
				color: #ffffff;
			}
		}
		.block_2_main{
			padding: 60px 16px 0 16px;
			.list_box{
				padding: 25px 0 60px 0;
				.list_el{
					display: flex;
					align-items: center;
					padding: 15px 0;
					border-bottom: 1px solid #D1D1D1;
					.tit{
						flex: 1;
						padding: 0 15px;
						font-size: 16px;
					}
					img{
						width: 36px;
					}
				}
			}
		}
	}
	//块1
	.block_1{
		.bg{
			width: 100%;
		}
		.block_1_main{
			padding: 60px 16px 0 16px;
			.num_main{
				padding-bottom: 40px;
			}
			.text_box{
				.txt{
					padding-top: 24px;
					div{
						padding: 2px 0;
						text-indent: 28px;
						line-height: 1.8;
					}
				}
				.tit{
					padding-top: 15px;
					font-size: 18px;
					font-weight: bold;
					color: #000000;
				}
			}
		}
	}
	//公共数字累加
	.num_box{
		display: inline-block;
		position: relative;
		top: 10px;
		span{
			font-size: 40px;
			color: #C8000A;
		}
		.icon_2{
			position: absolute;
			right: -18px;
			bottom: 15px;
			font-size: 10px;
		}
		.icon_1{
			position: absolute;
			right: -16px;
			top: 10px;
			font-size: 12px;
		}
		.num{
			font-size: 54px;
			color: #C8000A;
			line-height: 1;
			span{
				font-size: 40px;
				color: #C8000A;
			}
		}
	}
	//公共头部
	.top_box{
		.txt{
			padding-top: 5px;
			font-size: 12px;
		}
		.tit{
			font-size: 24px;
			font-weight: bold;
		}
		.tit_en{
			font-size: 18px;
			color: #B8B8B8;
		}
	}
	//轮播图
	.banner_box{
		width: 100%;
		position: relative;
		.swipe_box{
			.swiper_el{
				img.bg{
					width: 100%;
				}
			}
		}
	}
}
</style>